import type { U3141DocumentTypeEntry } from '../U3141Service';

const RF_LOT_DETAIL_ANNOTATED_LOT_CHAIN = 'rfLotDetailAnnotatedLotChain';

/** True si le lot possède au moins un document chaîne de lots annotée (hors soft delete — filtré côté API). */
export function u3141LotHasAnnotatedLotChainDocument(
  documentTypes: U3141DocumentTypeEntry[] | null | undefined,
): boolean {
  if (!Array.isArray(documentTypes) || documentTypes.length === 0) {
    return false;
  }
  return documentTypes.some((d) => d?.documentType === RF_LOT_DETAIL_ANNOTATED_LOT_CHAIN);
}
